export default "__VITE_ASSET__7692446e__"